<!-- 编辑页，测试页共享 -->
<template>
  <el-upload ref="uploadTemplate" class="upload-demo upload-demo1" :auto-upload="false" :action="uploadURL" :limit="1"
    :accept="acceptFile" :file-list="fileList" :on-exceed="handleExceed" :on-remove="uploadRemove"
    :on-change="uploadChange">
    <el-button slot="trigger" size="small" type="white" @click="resetUpload">更换模板文件</el-button>
  </el-upload>
</template>
<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import bus from '@/assets/js/bus'
  import busType from '@/assets/js/busType'

  export default {
    name: 'uploadFile',
    mixins: [],
    props: {},
    data() {
      return {
        uploadURL: this.$uploadChange.url,
        fileList: [],
        acceptFile: ''
      }
    },
    computed: {
      ...mapState(['labelState']),
      ...mapGetters(['editTemplate'])
    },
    components: {},
    watch: {},
    mounted() {
      //修正不能上传tiff文件
      this.acceptFile =
        'image/png,image/jpg,image/jpeg,.pdf,.docx,.doc,.xlsx,.xls,.PDF,.DOCX,.DOC,.XLSX,.XLS,.tiff,.tif,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    updated() { },
    methods: {
      handleExceed() { },
      uploadRemove(file, fileList) {
        this.fileList = fileList
        //console.log('移除',file,fileList)
      },
      resetUpload() {
        this.$refs.uploadTemplate.clearFiles()

        // 点击更换单证文件上传，关闭折叠面板
        // =>this.$parent = DocFields.vue
        if (this.$parent.$refs && this.$parent.$refs.editTexts) {
          this.$parent.$refs.editTexts.closeCollapse()
        }
      },
      uploadChange(file, fileList) {
        let size = file.size / 1024 / 1024
        const isLt2M = size < 60 && size !== 0

        if (size === 0) {
          this.$message.error('不支持空文件上传')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传失败，' + file.name + ' 大小超出60M')
          return false
        }

        this.fileList = fileList
        this.submitUpload()
      },
      uploadPromise() {
        this.fileData = new FormData()

        for (let i = 0; i < this.fileList.length; i++) {
          this.fileData.append('file', this.fileList[i].raw)
        }

        let category
        if (this.editTemplate.subTypeRule) {
          category = this.editTemplate.subTypeRule.category
        } else {
          category = this.editTemplate.category
        }

        return this.$axios({
          url:
            this.$uploadChange.url +
            '?category=' +
            category +
            '&certiType=' +
            this.$route.query.certiType,
          method: 'POST',
          timeout: 5 * 60 * 1000,
          header() {
            return {
              Authorization: localStorage.getItem(
                'BAILIAN-SHIBIE-TOKEN'
              )
            }
          },
          data: this.fileData
        })
      },
      async submitUpload() {
        // 真实上传逻辑
        if (this.fileList && this.fileList.length > 0) {
          this.$parent.areaLoading = true

          try {
            let res = await this.uploadPromise()

            this.$store.dispatch('setEditTemplate', null)

            let data = res.data.data
            if (data) {
              //调切换单证接口
              await this.switchDoc(data)

              bus.$emit(busType.RESETINDENTITY)

              this.$message.success('识别成功。')

              this.$parent.areaLoading = false
              location.reload()
            } else {
              this.$message.info('识别失败，请更换单证。')
            }
          } catch (e) {
            this.$parent.areaLoading = false
            console.log(e)
          }
        }
      },
      switchDoc(data) {
        let url = this.$resource.updateTemplate

        return this.$axios({
          url: url,
          method: 'post',
          data: {
            billNo: data.billNo,
            id: this.$route.query.id,
            thumbnail: data.imageList[0].resPath
          }
        })
      }
    }
  }
</script>
<style>
  .editpage {
    .upload-demo1 {
      position: absolute;
      top: 14px;
      right: 144px;
    }
  }
</style>